import { BreakPointCondition, SliderModal, useBreakpointIf } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { ScrollView } from 'native-base';
import React, { useCallback } from 'react';

import { SignedInRootStackParamList } from '../../../../routes/types';
import { ProductType } from '../../constants';

import { BlockModalForm } from './components/BlockModalForm';
import { HeaderSection } from './components/HeaderSection';

export const ProductsManagementBlockModal: React.FC = () => {
  const { params } =
    useRoute<RouteProp<SignedInRootStackParamList, 'ProductsManagementBlockModal'>>();
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');
  const direction = useBreakpointValue({ base: 'bottom', lg: 'right' });

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <SliderModal
      dismissWhenClickOutside={false}
      onDismiss={goBack}
      direction={direction}
      width={getSliderModalWidth()}>
      <HeaderSection goBack={goBack} direction={direction} />
      <ScrollView showsVerticalScrollIndicator={false}>
        <BlockModalForm
          productType={params.productTypeId as unknown as ProductType}
          goBack={goBack}
        />
      </ScrollView>
    </SliderModal>
  );
};
